import { Box, Typography } from "@mui/material";

export default function About() {
  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        backgroundColor: "background.paper"
      }}
    >
      <Box
        sx={{
          maxWidth: 1000,
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom>Über uns</Typography>

        <Typography sx={{ mt: 4, fontSize: "1.1rem", color: "text.primary" }}>
          EDEB-Estrichbau ist seit über 30 Jahren Ihr zuverlässiger Partner für
          professionelle Estrich- und Abbrucharbeiten im Rhein-Main-Gebiet.
        </Typography>

        <Typography sx={{ mt: 3, fontSize: "1.1rem", color: "text.primary" }}>
          Unsere Kunden schätzen besonders unsere Fachkenntnisse,
          Termintreue, saubere Ausführung sowie unser faires
          Preis-Leistungs-Verhältnis.
        </Typography>

        <Typography sx={{ mt: 3, fontSize: "1.1rem", color: "text.primary" }}>
          Das Handwerk ist unsere Leidenschaft – und genau diese
          Leidenschaft ist die Basis unserer Qualität und
          Kundenzufriedenheit.
        </Typography>
      </Box>
    </Box>
  );
}
